import React from 'react';
import { Link } from 'react-router-dom';
import './Layout.css'; // Re-use some styles for consistency

const Unauthorized = () => {
  return (
    <div className="unauthorized-container" style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Доступ запрещён</h1>
      <p>У вас нет необходимых прав для просмотра этой страницы.</p>
      <Link to="/" className="btn">Вернуться на главную</Link>
    </div>
  );
};

export default Unauthorized;
